import React from "react"
import PropTypes from "prop-types"
import "./marketing.scss"
import "./virgin-marketing-2.scss"
import Button from "../shared/button/text-button"
import house from "images/splashScreens/virgin-house.png"
import thumb from "images/splashScreens/virgin-thumb.png"
import download from "images/splashScreens/virgin-download.png"
import repair from "images/splashScreens/virgin-repair.png"

const MarketingVirgin = ({ handleButtonClick }) => (
  <div className="marketing-page--virgin">
    <div className="marketing-page--virgin--sub">
      <div className="marketing-page--virgin--sub--banner">
        <h1>Why Choose Virgin Media?​</h1>
      </div>
      <div className="marketing-page--virgin--text-section">
        <h3>
          We don't like to boast (well, not too much), but with the UK's fastest
          widely available broadband, great TV packages and a trophy cabinet to
          fit to bursting, there are plenty of reasons to choose us.
        </h3>
      </div>
      <div className="marketing-page--virgin--row">
        <div className="marketing-page--virgin--row--column">
          <img src={house} alt="" />
          <p>Ultrafast, ultra-reliable</p>
        </div>
        <div className="marketing-page--virgin--row--column">
          <img src={thumb} alt="" />
          <p>14 day money back guarantee</p>
        </div>
        <div className="marketing-page--virgin--row--column">
          <img src={download} alt="" />
          <p>Unlimited downloads - no data caps</p>
        </div>
        <div className="marketing-page--virgin--row--column">
          <img src={repair} alt="" />
          <p>Free servicing and repairs</p>
        </div>
      </div>
      <div className="marketing-page--virgin--text-section">
        <p>
          Broadband Genie have crowned us Fastest Broadband Provider for 2019,
          and uSwitch have named us Fastest Broadband Provider for the 10th year
          in a row!
        </p>
      </div>
      <div className="marketing-page marketing-button-container">
        <Button text="Continue" onClick={handleButtonClick} />
      </div>
    </div>
  </div>
)

MarketingVirgin.propTypes = {
  handleButtonClick: PropTypes.func.isRequired
}

export default MarketingVirgin
